import React from 'react'

import Image from '@/image.js'

const TeamPhoto = ({ content }) => {
  return (
    <div className='x py1'>
      <div className='container--xl ma ac'>
        <h2>{content.title}</h2>
        <div className='f jcb fw aic x'>
          <Image imageId={content.imageId} className='x' />
        </div>
      </div>
    </div>
  )
}

export default TeamPhoto